import { useCallback, useMemo } from 'react';
import { TableFetchParams, tableQueryMaker, TableState } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetTransactionsRepoType, IGetTransactionsRepo } from '../../repos';
import { transactionKeys } from '@modules/transactions';

export const useTransactionsTableContext = () => {
  const getTransactionsRepo = useService<IGetTransactionsRepo>(GetTransactionsRepoType);

  const handleFetch = useCallback(
    async (params: TableFetchParams) => {
      const result = await getTransactionsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getTransactionsRepo],
  );

  const defaultState = useMemo<Partial<TableState>>(
    () => ({
      hiddenColumns: [transactionKeys.amount.currency],
    }),
    [],
  );

  return { handleFetch, defaultState };
};
